export default {"src":"/_next/static/media/salesforce.5e33b57d.svg","height":47,"width":62,"blurWidth":0,"blurHeight":0};